export default __webpack_public_path__ + "static/media/prize-picks.a4e19897.jpg";